import moment from "moment";
import React from "react";
import { marpolSelectors } from "../../../../../redux/app/marpol";
import { TBFL1Record } from "../../../../../redux/app/bfl-1/@types";
import { TBFL1C1 } from "../../../../../redux/app/bfl-1/groups/group-c";
import BFL1TableRows from "../BFL1TableRows";
import { IStore } from "../../../../../redux/store";
import { ConnectedProps, connect } from "react-redux";

type OwnProps = {
	bfl1Record: TBFL1Record;
	isStrikedOff?: boolean;
};
type BFL1C1PreviewProps = React.PropsWithChildren<OwnProps>;
function BFL1C1Preview(props: BFL1C1PreviewProps & PropsFromRedux) {
	const bfl1Record = props.bfl1Record as TBFL1C1;

	const { item1, item2, item3, item4, item5, item6, item7, item9, item10 } =
		bfl1Record;

	const operationDate = moment(bfl1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<BFL1TableRows
				record={bfl1Record}
				tableRows={[
					[operationDate, "C", "1", renderItemC1()],
					[null, null, "2", renderItemC2()],
					[null, null, "3", renderItemC3()],
					[null, null, "4", renderItemC4()],
					[null, null, "5", renderItemC5()],
					[null, null, "6", renderItemC6()],
					[null, null, "7", renderItemC7()],
					[null, null, "9", renderItemC9()],
					[null, null, "10", renderItemC10()],
					[null, null, "NOTE", bfl1Record.remarks],
				]}
			/>
		);
	}

	function renderItemC1() {
		if (item1.place === "PORT")
			return (
				<h6>
					{operationDate}, {item1.portName}
				</h6>
			);
		return (
			<h6>
				{operationDate}, <br />
				STARTED AT: {item1.startPosition.latitude},{" "}
				{item1.startPosition.longitude} <br />
				FINISHED AT: {item1.stopPosition.latitude},{" "}
				{item1.stopPosition.longitude}
			</h6>
		);
	}

	function renderItemC2() {
		if (item2.remarks) return item2.remarks;
		return null;
	}

	function renderItemC3() {
		if (item3.remarks) return item3.remarks;
		return null;
	}

	function renderItemC4() {
		if (item4.remarks) return item4.remarks;
		return null;
	}

	function renderItemC5() {
		if (item5.remarks) return item5.remarks;
		return null;
	}

	function renderItemC6() {
		if (item6.remarks) return item6.remarks;
		return null;
	}

	function renderItemC7() {
		if (item7.remarks) return item7.remarks;
		return null;
	}

	function renderItemC9() {
		if (item9.remarks) return item9.remarks;
		return null;
	}

	function renderItemC10() {
		if (item10.remarks) return item10.remarks;
		return null;
	}

	return renderMain();
}

function mapStateToProps(store: IStore) {
	const marpolStore = marpolSelectors._getStore(store);

	return {};
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BFL1C1Preview);
